export default __webpack_public_path__ + "static/media/sql.034691de.svg";